import { useGrowthBookFlag } from '../../hooks/useGrowthBookFlag/useGrowthBookFlag';

export const useIsHotpotEnabled = (): boolean =>
  useGrowthBookFlag('is_hotpot_enabled') === true;
